import type { ReactNode } from 'react';
import { Panel } from './Panel';

/**
 * A row of `Stat` tiles, as many as fit at 13.5rem each — three from an iPad
 * mini in portrait (the narrowest tablet column) up, one on a phone. Fewer tiles keep
 * that width rather than stretching across the row.
 */
export function StatGrid({ children }: { children: ReactNode }) {
  return <div className="stat-grid">{children}</div>;
}

/**
 * One headline number on its own card. `children` go under the value, for a
 * footnote that qualifies it.
 */
export function Stat({
  label,
  value,
  tone,
  children,
}: {
  label: string;
  value: ReactNode;
  tone?: 'danger';
  children?: ReactNode;
}) {
  return (
    <Panel as="div">
      <p className="stat-label">{label}</p>
      <p
        className={
          tone === 'danger' ? 'stat-value stat-value-danger' : 'stat-value'
        }
      >
        {value}
      </p>
      {children}
    </Panel>
  );
}
